"use strict";
const { default: Axios } = require("axios");

import utilities from './../components/utilities.js';
const classUtilitites = new utilities;




// Class definition
var KTAppChat = function () {
	var _chatAsideEl;
	var _chatAsideOffcanvasObj;
	var _chatContentEl;
	var recorder;
	var audio_stream;
	var timeout_status;
	var preview;

	// Private functions
	var _initAside = function () {
		// Mobile offcanvas for mobile mode
		_chatAsideOffcanvasObj = new KTOffcanvas(_chatAsideEl, {
			overlay: true,
			baseClass: 'offcanvas-mobile',
			//closeBy: 'kt_chat_aside_close',
			toggleBy: 'kt_app_chat_toggle'
		});

		// User listing
		var cardScrollEl = KTUtil.find(_chatAsideEl, '.scroll');
		var cardBodyEl = KTUtil.find(_chatAsideEl, '.card-body');
		var searchEl = KTUtil.find(_chatAsideEl, '.input-group');

		if (cardScrollEl) {
			// Initialize perfect scrollbar(see:  https://github.com/utatti/perfect-scrollbar)
			KTUtil.scrollInit(cardScrollEl, {
				mobileNativeScroll: true,  // Enable native scroll for mobile
				desktopNativeScroll: false, // Disable native scroll and use custom scroll for desktop
				resetHeightOnDestroy: true,  // Reset css height on scroll feature destroyed
				handleWindowResize: true, // Recalculate hight on window resize
				rememberPosition: true, // Remember scroll position in cookie
				height: function () {  // Calculate height
					var height;

					if (KTUtil.isBreakpointUp('lg')) {
						height = KTLayoutContent.getHeight();
					} else {
						height = KTUtil.getViewPort().height;
					}

					if (_chatAsideEl) {
						height = height - parseInt(KTUtil.css(_chatAsideEl, 'margin-top')) - parseInt(KTUtil.css(_chatAsideEl, 'margin-bottom'));
						height = height - parseInt(KTUtil.css(_chatAsideEl, 'padding-top')) - parseInt(KTUtil.css(_chatAsideEl, 'padding-bottom'));
					}

					if (cardScrollEl) {
						height = height - parseInt(KTUtil.css(cardScrollEl, 'margin-top')) - parseInt(KTUtil.css(cardScrollEl, 'margin-bottom'));
					}

					if (cardBodyEl) {
						height = height - parseInt(KTUtil.css(cardBodyEl, 'padding-top')) - parseInt(KTUtil.css(cardBodyEl, 'padding-bottom'));
					}

					if (searchEl) {
						height = height - parseInt(KTUtil.css(searchEl, 'height'));
						height = height - parseInt(KTUtil.css(searchEl, 'margin-top')) - parseInt(KTUtil.css(searchEl, 'margin-bottom'));
					}

					// Remove additional space
					height = height - 2;

					return height;
				}
			});
		}
	}

	const showFullTextWhats = function () {
		if( $("#expand-select-message").length > 0 ){
			$("#expand-select-message").fadeIn(150, function(){
				$(this).find("#select-full-text-message").html( $( "select#idTemplate option:selected" ).data('content') )
			});
		}
	}

	const loaderJs = function(){
		$('#loading-div').fadeToggle(200).css('display', 'flex');
	}

	const scrollMessages = function () {
		// scroll v3 funcionando
		if($('.messages-chat-whats').hasClass('v3')){
			if($('#kt_chat_content .resp-baloon').length > 0) {
				// console.log('scroll v3');
				$('.messages-chat-whats').animate({
					scrollTop: ($('#kt_chat_content .resp-baloon').last().offset()!=undefined?$('#kt_chat_content .resp-baloon').last().offset().top:0)
				}, 1000);
			}
		} else {
			// console.log('scroll v2');
			$('.scroll').animate({
				scrollTop: $('.messageBody')[0] !== undefined ? $('.messageBody')[0].scrollHeight : 1
			}, 1000);
		}
	}

	window.scrollToPaginateInfinity = function (e) {
		var elem 				= $(e.currentTarget);
		const triggerPagination = "#trigger-chat-pagination";
		if ((elem.scrollTop() == 0))
		{				
			if(parseInt($(triggerPagination).attr('data-pagenow')) > parseInt($(triggerPagination).attr('data-totalpage'))) return;
			$(triggerPagination).trigger('click');
		}

	}

	const start = function () {
		let element = $(this);
		let url = element.attr('href');
		loaderJs();

		Axios.post(url)
			.then(function (response) {
				let data = response.data;

				if (data.error == false) {

					data.result.targets.forEach(function (value, index) {
						$('.' + value.target).html(value.html);
					});
					KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));

					enterChannel(element.data('chat_id'));

					callbackChat();

					/* scrollMessages();
					showFullTextWhats();
					loaderJs();
					classUtilitites.formSelects();
					// textarea height dynamic in chat   
				    handlerChangeTextareaChat(); */
				}
			});

		return false;
	}

	const callbackChat = () => {
		scrollMessages();
		showFullTextWhats();
		loaderJs();
		classUtilitites.formSelects();
		// textarea height dynamic in chat   
		handlerChangeTextareaChat();

		if($('.chat-scroll-pagination').length > 0) {
			console.log('tem chat-scroll-pagination');
			$('.chat-scroll-pagination').on('scroll', scrollToPaginateInfinity)
		}
	}

	const testeCall = () => {
		console.log('carregou import!');
	}

	const enterChannel = function (id) {
		const roomName = 'room.' + client_name + '.' + id;

		Echo.leave(roomName);
		Echo.private(roomName)
			.listen('SendMessage', (response) => {
				$('#chat-' + id + ' .messages').append(response.html);
				scrollMessages();

				var context = new AudioContext();
				console.log(context.state )
				if(context.state == "running"){
					document.getElementById('audio-notification').play()
				}
			});
	}

	// function listenChannel() {

	// 	if (typeof chat_active == 'undefined') {
	// 		return false;
	// 	}

	// 	chat_active.forEach((value) => {
	// 		Echo.private('room.' + value)
	// 			.listen('SendMessage', (response) => {

	// 				// const data = {
	// 				// 	title: "Nova mensagem de chat. Oportunidade #" + response.chatMessage.chat.opportunity_id,
	// 				// 	id_notifications_types: 1,
	// 				// 	id_module: 1,
	// 				// 	content: response.chatMessage.content,
	// 				// 	url: HOST_URL + "/crm/detail/" + response.chatMessage.chat.opportunity_id,
	// 				// 	id_user: user_logged_id
	// 				// };

	// 				// Axios.post(HOST_URL + '/notification/store', data)
	// 				// 	.then(function (response) {
	// 				// 		let data = response.data;
	// 				// 	});
	// 			});
	// 	});
	// }

	function sendMessage() {
		let element = $(this);
		let url = element.attr('action');
		let data = element.serialize();

		$('.chat-send').attr('disabled', 'disabled');
		$('.chat-send').each(function () {
			let el = $(this);
			let val = el.html();

			el.attr('data-val', val);
			el.html(el.attr('data-wait'));
		});

		Axios.post(url, data)
			.then(function (response) {

				let data = response.data;

				if (data.error === false) {
					let result = data.result;
					$('.messageBody .messages').append(result.html);
					$('textarea[name="content"]').val("");

					scrollMessages();
					//$('.act-chat-start').trigger('click');//start wrapper chat

				} else {
					Swal.fire({
						icon: "error",
						text: data.message,
						showCancelButton: false,
					})
					if(data.result.method != undefined){
						setTimeout(function () {
							location.reload();
						}, 1000);
					}
				}

				$('.chat-send').removeAttr('disabled');
				$('.chat-send').each(function () {
					let el = $(this);

					el.html(el.attr('data-val'));
				});
			}).catch((error) => {
				const data = JSON.parse(error.config.data);
				console.error("request data", data);
			  });

		return false;
	}






	function sendEmail() {
		let element = $(this);
		$('#send-email').click();
		
		// $('.email-send').attr('disabled', 'disabled');
		// $('.email-send').each(function () {
		// 	let el = $(this);
		// 	let val = el.html();

		// 	el.attr('data-val', val);
		// 	el.html(el.attr('data-wait'));
		// });

		return false;
	}


	const selectToggleHelperToChat = function(){
		$("#chatSelectText").toggle()
		// $("#chatSelectText").toggle(10, function () {
		// 	if( $(this).css('display') == 'flex' ) {
		// 		showBtsChatDynamics('send');
		// 	} else {
		// 		showBtsChatDynamics('audio');
		// 	}
		// })
	}

	const showBtsChatDynamics = function (tp) { 

		if(tp === 'send'){
			document.getElementById('send-whatsapp').style.display='flex';
			document.getElementById('recordButton').style.display='none';
		} else {
			document.getElementById('send-whatsapp').style.display='none';
			document.getElementById('recordButton').style.display='flex';
		}

	}

	// textarea height dynamic in chat
	function handlerChangeTextareaChat() {
		const textarea = document.querySelector('.textareaDynamicHeight');
		//const textarea = document.getElementById('content');
		//console.log(textarea)
		let userDefinedHeight = 0;

		if(textarea){
			textarea.addEventListener('input', () => {
			resizeTextArea(textarea, userDefinedHeight);
			});

			textarea.addEventListener('mouseup', () => {
				const { height, minHeight } = textarea.style;
				userDefinedHeight = height === minHeight ? 0 : parseInt(height, 10);
			});
		}
	}

	function resizeTextArea(textarea, userDefinedHeight = 0) {
		const { style, value } = textarea;

		// if(value.length > 0){
		// 	showBtsChatDynamics('send');
		// } else {
		// 	showBtsChatDynamics('audio');
		// }

		// The 4 corresponds to the 2 2px borders (top and bottom):
		style.height = style.minHeight = 'auto';
		style.minHeight = `${ Math.min(textarea.scrollHeight + 4, parseInt(textarea.style.maxHeight)) }px`;
		style.height = `${ Math.max(textarea.scrollHeight + 4, userDefinedHeight) }px`;
	}

	const asideChatCustomToggle = function(){
		console.log(this)
		this.classList.toggle("actived");
		document.getElementById('kt_chat_aside').classList.toggle('sidechat-minimize');
		document.getElementById('kt_chat_content').classList.toggle('chat-adjust-aside');
	}

	const disconnectAll = function(){
		Echo.leaveChannel();
		console.log("exec - disconnectAll");
	}

	const alertSendTemplateBefore =  () => {
		Swal.fire({
			icon: "warning",
			text: "Primeiro envie uma template",
			showCancelButton: false,
		})
	}

	return {

		callbackChat 	: callbackChat,
		testeCall 		: testeCall,
		scrollMessages  : scrollMessages,
		scrollToPaginateInfinity : scrollToPaginateInfinity,

		// Public functions
		init: function () {

			// Elements
			_chatAsideEl = KTUtil.getById('kt_chat_aside');
			_chatContentEl = KTUtil.getById('kt_chat_content');

			// Init aside and user list
			_initAside();

			// Init inline chat example
			KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));

			// Trigger click to show popup modal chat on page load
			if (KTUtil.getById('kt_app_chat_toggle')) {
				setTimeout(function () {
					KTUtil.getById('kt_app_chat_toggle').click();
				}, 1000);
			}

			$(document).on('click', '.email-send', sendEmail);
			$(document).on('click', '.act-chat-start', start);
			$(document).on('submit', '#chat-send-message', sendMessage);
			$(document).on("change", "select#idTemplate", showFullTextWhats);
			$(document).on("click", "#toggleSelectHelper", selectToggleHelperToChat);
			$(document).on("click", "#kt_chat_aside_custom_toggle", asideChatCustomToggle);
			$(document).on("click", ".js-alert-template", alertSendTemplateBefore);

			$(document).on("click", "#disconnect-all", disconnectAll)
			// listenChannel();
		}
	};
}();

export default KTAppChat;

// jQuery(document).ready(function () {
// 	KTAppChat.init();
// });
